var _rect, _circle, _circle2, _circle3, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStickerFace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 42,
    rx: 20,
    fill: "#EAE1DB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "#B8A29C",
    strokeOpacity: 0.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 17,
    fill: "#EAE1DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 14.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM29 14.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM21.587 19.69a1 1 0 00-1.174 1.62l1.174-1.62zm6 1.62a1 1 0 00-1.174-1.62l1.174 1.62zM24 20.5c-.868 0-1.692-.287-2.413-.81l-1.174 1.62c1.032.747 2.26 1.19 3.587 1.19v-2zm2.413-.81c-.72.523-1.545.81-2.413.81v2c1.326 0 2.555-.443 3.587-1.19l-1.174-1.62z",
    fill: "#B8A29C"
  })));
}

export default SvgStickerFace;